import { useStyletron } from "baseui";
import { HeadingXLarge, ParagraphLarge } from "baseui/typography";
import React from "react";
import type { DocsInterfaceProps } from "../../../../src/chrome/DocsInterface";
import { DocsInterface } from "../../../../src/chrome/DocsInterface";
import { SplashCard, SplashCardGrid, SplashContentContainer, colors } from "../../../../src/components/SplashPage";

const BigCommerceTutorialsLandingPage = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>BigCommerce tutorials</HeadingXLarge>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
          }}
        >
          Learn to build full-stack BigCommerce apps.
        </ParagraphLarge>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200 })}>
          <SplashCard
            title="Automatically add search keywords to products"
            color={colors.white}
            body="Learn how to build a full-stack, single-click app that adds search keywords to products."
            href="/guides/tutorials/bigcommerce/product-search-keywords"
            copy="Start building →"
          />
          <SplashCard
            title="Build size charts for Catalyst storefronts"
            color={colors.white}
            body="Learn how to build App Extensions and call your Gadget API from Catalyst storefronts."
            href="/guides/tutorials/bigcommerce/size-charts"
            copy="Start building →"
          />
        </SplashCardGrid>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default BigCommerceTutorialsLandingPage;
